import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    height: '100%',
  },
  card: {
    height: '100%',
    position: 'relative',
    overflow: 'visible',
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    color: 'white',
  },
  cardWarning: {
    height: '100%',
    position: 'relative',
    overflow: 'visible',
    background: 'linear-gradient(45deg, #FF9800 30%, #FFB74D 90%)',
    color: 'white',
  },
  iconBox: {
    position: 'absolute',
    top: -20,
    right: 20,
    height: 60,
    width: 60,
    borderRadius: '50%',
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.14)',
  },
  iconBoxWarning: {
    position: 'absolute',
    top: -20,
    right: 20,
    height: 60,
    width: 60,
    borderRadius: '50%',
    background: 'linear-gradient(45deg, #FF9800 30%, #FFB74D 90%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.14)',
  },
  icon: {
    fontSize: 30,
    color: 'white',
  },
  statsBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  statsIcon: {
    color: '#4CAF50',
    marginRight: theme.spacing(1),
  },
  statsIconDown: {
    color: '#f44336',
    marginRight: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
